import { component_tool, framework_tool } from '@/tool'
import moment from "moment";
import React from 'react';
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

let ref;
//配置项
let componentName = 'hostLiveRecord'//hostLiveRecord

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "personId",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fulName",
    tableItem: {}
  },
  {
    title: "姓名",
    name: "fullNameSearch",
    dataIndex: "fullNameSearch",
    searchItem: {},
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    tableItem: {},
  },
  {
    title: "账号",
    name: "userNameSearch",
    dataIndex: "userNameSearch",
    searchItem: {}
  },
  {
    title: "用户属性",
    name: "userType",
    dataIndex: "userType",
    tableItem: {},
    dict: [
      { code: 0, codeName: "培训平台用户" },
      { code: 5, codeName: "服务商用户" },
      { code: 4, codeName: "经销商用户" },
      { code: 3, codeName: "OEM部门用户" }
    ],
  },

  {
    title: "账号状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "激活" },
      { code: 0, codeName: "禁用" },
    ],
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {},
  },
  {
    title: "组织名称",
    name: "orgIds",
    dataIndex: "orgIds",
    searchItem: {
      diy: WizTableForm,
      selectType:"checkbox",
      ...organizationConfig
    }
  },
  {
    title: "组织编码",
    name: "orgCode",
    dataIndex: "orgCode",
    tableItem: {}
  },
  {
    title: "岗位",
    name: "positionIds",
    dataIndex: "positionIds",
    searchItem: {
      ...positionConfig,
      diy: WizTableForm,
      selectType: 'checkbox',
    },
  },
  {
    title: "岗位",
    name: "positionName",
    dataIndex: "positionName",
    tableItem: {},
  },
  {
    title: "任职状态",
    name: "jobState",
    dataIndex: "jobState",
    tableItem: {},
    dict: [
      { code: 0, codeName: "离职" },
      { code: 1, codeName: "在职" },
    ],
  },
  {
    title: "是否参训",
    name: "isAttend",
    dataIndex: "isAttend",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
  },
  {
    title: "进入时间",
    name: "startTime",
    dataIndex: "startTime",
    tableItem: {},
  },
  {
    title: "离开时间",
    name: "endTime",
    dataIndex: "endTime",
    tableItem: {},
    // searchItem: {
    //   type: 'date',
    //   format: 'YYYY-MM-DD HH:mm',
    //   showTime: {
    //     format: 'HH:mm'
    //   }
    // }
  },
  {
    title: "累计观看时长(分钟)",
    name: "durationMinute",
    dataIndex: "durationMinute",
    tableItem: {}
  },
  {
    title: "累计进入次数",
    name: "countNumber",
    dataIndex: "countNumber",
    tableItem: {}
  },
];

const templateConfig = {


    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ["export", "synchronizeTrainingRecords"],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['openDateTime'] && value['openDateTime'].length === 2) {
              value['startTime'] = moment(value['openDateTime'][0]).format("YYYY/MM/DD") + ' 00:00:00';
              value['endTime'] = moment(value['openDateTime'][1]).format("YYYY/MM/DD") + ' 23:59:59';
            }
            // delete value['openDateTime']
            return value
          },
          buttons: [
            {
              key: "export",
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export"
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            },
            {
              key: "synchronizeTrainingRecords",
              custom: true,
              params: { icon: 'reload', children: '同步参训记录', type: 'reload'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "syncLiveRecord"
                },
                formatParams: (rows, record, filter) => {
                  let ids = [];
                  if (rows && rows instanceof Array) {
                    rows.forEach(element => {
                      ids.push(element.id)
                    });
                  }
                  return {
                    ids: ids
                  };
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['viewJobs'],
        rowOperateView: [
          {
            key: "viewJobs",
            custom: true,
            params: { children: "查看任职" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/live/liveList/lookPositionInfo"
              }
            }
          }
        ],
        commonOperate: {}
      }
    }


};

const apis =(liveId)=> {
  return{
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {
          entityId : liveId
        }
      }
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@listByCondition`,
        apiParams: {
          entityId : liveId
        }
      }
    },
    syncLiveRecord: {
      path: `liveRecord/syncLiveRecord`,
      payload: {
        key: `${componentName}@syncLiveRecord`,
        apiParams: {id : liveId}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis : apis(args.liveId),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
